// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResponseStartTask
 */
export interface ResponseStartTask {}

/**
 * Check if a given object implements the ResponseStartTask interface.
 */
export function instanceOfResponseStartTask(value: object): value is ResponseStartTask {
  return true;
}

export function ResponseStartTaskFromJSON(json: any): ResponseStartTask {
  return ResponseStartTaskFromJSONTyped(json, false);
}

export function ResponseStartTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseStartTask {
  return json;
}

export function ResponseStartTaskToJSON(json: any): ResponseStartTask {
  return ResponseStartTaskToJSONTyped(json, false);
}

export function ResponseStartTaskToJSONTyped(
  value?: ResponseStartTask | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
